// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Utility classes and mixins */

/* Custom animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.5s ease-in-out;
}

/* Responsive utilities */
.mobile-only {
  display: block;
}

.desktop-only {
  display: none;
}

@media (min-width: 768px) {
  .mobile-only {
    display: none;
  }
  
  .desktop-only {
    display: block;
  }
}

/* Spacing utilities */
.space-y-1 > * + * {
  margin-top: 0.25rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.space-y-3 > * + * {
  margin-top: 0.75rem;
}

.space-y-4 > * + * {
  margin-top: 1rem;
}

.space-x-1 > * + * {
  margin-left: 0.25rem;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

.space-x-3 > * + * {
  margin-left: 0.75rem;
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

/* Flex utilities */
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Text utilities */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-balance {
  text-wrap: balance;
}

/* Border utilities */
.border-top {
  border-top-width: 1px;
  border-top-style: solid;
}

.border-bottom {
  border-bottom-width: 1px;
  border-bottom-style: solid;
}

/* Shadow utilities */
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/styles/utils/index.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,2CAA2C;AAC7C;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,mFAAmF;AACrF","sourcesContent":["/* Utility classes and mixins */\n\n/* Custom animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n/* Responsive utilities */\n.mobile-only {\n  display: block;\n}\n\n.desktop-only {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .mobile-only {\n    display: none;\n  }\n  \n  .desktop-only {\n    display: block;\n  }\n}\n\n/* Spacing utilities */\n.space-y-1 > * + * {\n  margin-top: 0.25rem;\n}\n\n.space-y-2 > * + * {\n  margin-top: 0.5rem;\n}\n\n.space-y-3 > * + * {\n  margin-top: 0.75rem;\n}\n\n.space-y-4 > * + * {\n  margin-top: 1rem;\n}\n\n.space-x-1 > * + * {\n  margin-left: 0.25rem;\n}\n\n.space-x-2 > * + * {\n  margin-left: 0.5rem;\n}\n\n.space-x-3 > * + * {\n  margin-left: 0.75rem;\n}\n\n.space-x-4 > * + * {\n  margin-left: 1rem;\n}\n\n/* Flex utilities */\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* Text utilities */\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-balance {\n  text-wrap: balance;\n}\n\n/* Border utilities */\n.border-top {\n  border-top-width: 1px;\n  border-top-style: solid;\n}\n\n.border-bottom {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n}\n\n/* Shadow utilities */\n.shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
